var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-select-biz-component',_vm._g(_vm._b({attrs:{"value":_vm.value,"ellipsisLength":25,"listUrl":_vm.url.list,"columns":_vm.columns,"multiple":_vm.multiple}},'j-select-biz-component',_vm.attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }